/* eslint-disable import/prefer-default-export */
import { ErrorArgsType } from '../types/Types';

export class TextHelper {
  static getErrorTitleKeyTransformed = (titleArguments: ErrorArgsType[]) => {
    let titleKey = '';
    // eslint-disable-next-line no-unused-expressions
    titleArguments?.forEach((err: ErrorArgsType) => {
      if (err.key) {
        titleKey = err.key.split('.').join('-');
      }
    });

    return titleKey;
  };

  static getErrorMessageKeyTransformed = (
    messageArguments: ErrorArgsType[],
  ) => {
    let messageKey = '';
    // eslint-disable-next-line no-unused-expressions
    messageArguments?.forEach((err: ErrorArgsType) => {
      if (err.key) {
        messageKey = err.key.split('.').join('-');
      }
    });

    return messageKey;
  };

  static testNombre = (nombre: string) => {
    return TextHelper.isAsciiPrintableName(nombre);
  };

  static testNombreVia = (nombreVia: string) => {
    return TextHelper.isAsciiPrintableAddress(nombreVia);
  };

  static testLocalidad = (nombre: string) => {
    return TextHelper.isAsciiPrintableLocality(nombre);
  };

  static testLocalidadEntrega = (nombre: string) => {
    let values = nombre;
    if (!values) {
      const elements = document.getElementsByName('localidadEntrega');
      values =
        elements.length > 0 ? (elements[0] as HTMLInputElement).value : '';
    }
    return TextHelper.isAsciiPrintableLocality(values);
  };

  static testPostalCode = (nombre: string) => {
    const values = nombre;
    // const elements = document.getElementsByName('codPostal');
    // values =
    //   elements.length > 0
    //     ? (elements[elements.length - 1] as HTMLInputElement).value
    //     : '';

    const expRegCPO = new RegExp(
      /(^[0-9]{5}$)|(^(GX11 1AA)$)|(^([Aa][Dd])[1234567]{1}(00)$)/i,
    );
    return expRegCPO.test(values);
  };

  static isAsciiPrintableName = (value: string) => {
    let isValid = false;
    let element = '' as string;
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < value.length; index++) {
      element = value[index] as string;
      const ch = element.charCodeAt(0) as number;
      if (
        ch === 32 || // espacio
        ch === 39 || // '
        ch === 40 || // (
        ch === 41 || // )
        ch === 45 || // -
        ch === 46 || // .
        (ch >= 65 && ch <= 90) || // letras mayusculas
        (ch >= 96 && ch <= 122) || // letras minusculas
        ch === 199 || // ch === 128 || Ç
        ch === 252 || // ch === 129 || ü
        ch === 233 || // ch === 130 || é
        ch === 231 || // ch === 135 || ç
        ch === 201 || // ch === 144 || É
        ch === 220 || // ch === 154 || Ü
        ch === 225 || // (ch >= 160 && ch <=167) || á
        ch === 237 ||
        ch === 243 ||
        ch === 250 ||
        ch === 241 ||
        ch === 209 ||
        ch === 170 ||
        ch === 186 ||
        ch === 193 || // ch === 181 ||
        ch === 205 || // ch === 214 ||
        ch === 211 || // ch === 224 ||
        ch === 218 || // ch === 233 ||
        ch === 180 || // ch === 239
        ch === 224 || // à
        ch === 192 || // À
        ch === 232 || // è
        ch === 200 || // È
        ch === 236 || // ì
        ch === 204 || // Ì
        ch === 242 || // ò
        ch === 210 || // Ò
        ch === 249 || // ù
        ch === 217 // Ù
      ) {
        isValid = true;
      } else {
        return false;
      }
    }
    return isValid;
  };

  static isAsciiPrintableAddress = (value: string) => {
    let isValid = false;
    let element = '' as string;
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < value.length; index++) {
      element = value[index] as string;
      const ch = element.charCodeAt(0) as number;
      if (
        ch === 32 || // espacio
        ch === 39 || // '
        ch === 40 || // (
        ch === 41 || // )
        ch === 45 || // -
        ch === 44 || // ,
        ch === 46 || // .
        ch === 47 || // /
        (ch >= 48 && ch <= 57) || // numeros
        (ch >= 65 && ch <= 90) || // letras mayusculas
        (ch >= 96 && ch <= 122) || // letras minusculas
        ch === 199 || // ch === 128 || Ç
        ch === 252 || // ch === 129 || ü
        ch === 233 || // ch === 130 || é
        ch === 231 || // ch === 135 || ç
        ch === 201 || // ch === 144 || É
        ch === 220 || // ch === 154 || Ü
        ch === 225 || // (ch >= 160 && ch <=167) || á
        ch === 237 ||
        ch === 243 ||
        ch === 250 ||
        ch === 241 ||
        ch === 209 ||
        ch === 170 ||
        ch === 186 ||
        ch === 193 || // ch === 181 ||
        ch === 205 || // ch === 214 ||
        ch === 211 || // ch === 224 ||
        ch === 218 || // ch === 233 ||
        ch === 180 || // ch === 239
        ch === 227 || // ã
        ch === 320 || // ŀ
        ch === 319 || // Ŀ
        ch === 183 || // ·
        ch === 224 || // à
        ch === 192 || // À
        ch === 232 || // è
        ch === 200 || // È
        ch === 236 || // ì
        ch === 204 || // Ì
        ch === 242 || // ò
        ch === 210 || // Ò
        ch === 249 || // ù
        ch === 217 || // Ù
        ch === 228 || // ä
        ch === 235 || // ë
        ch === 239 || // ï
        ch === 246 || // ö
        ch === 196 || // Ä
        ch === 203 || // Ë
        ch === 207 || // Ï
        ch === 214 // Ö
      ) {
        isValid = true;
      } else {
        return false;
      }
    }
    return isValid;
  };

  static isAsciiPrintableLocality = (value: string) => {
    let isValid = false;
    let element = '' as string;
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < value.length; index++) {
      element = value[index] as string;
      const ch = element.charCodeAt(0) as number;
      if (
        ch === 32 || // space
        ch === 45 || // -
        ch === 39 || // '
        (ch >= 65 && ch <= 90) || // letras mayusculas
        (ch >= 96 && ch <= 122) || // letras minusculas
        ch === 241 || // ñ
        ch === 209 || // Ñ
        ch === 231 || // ç
        ch === 199 || // Ç
        ch === 252 || // ü
        ch === 220 || // Ü
        ch === 225 || // á
        ch === 193 || // Á
        ch === 233 || // é
        ch === 201 || // É
        ch === 237 || // í
        ch === 205 || // Í
        ch === 243 || // ó
        ch === 211 || // Ó
        ch === 250 || // ú
        ch === 218 || // Ú
        ch === 224 || // à
        ch === 192 || // À
        ch === 232 || // è
        ch === 200 || // È
        ch === 236 || // ì
        ch === 204 || // Ì
        ch === 242 || // ò
        ch === 210 || // Ò
        ch === 249 || // ù
        ch === 217 || // Ù
        ch === 40 || // (
        ch === 41 || // )
        ch === 47 // /
      ) {
        isValid = true;
      } else {
        return false;
      }
    }
    return isValid;
  };
}
